module.exports = __webpack_public_path__ + "static/media/success-white.900681eb.svg";